import { render, staticRenderFns } from "./TheSideNav.vue?vue&type=template&id=a09a665a&scoped=true&"
import script from "./TheSideNav.vue?vue&type=script&lang=ts&"
export * from "./TheSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./TheSideNav.vue?vue&type=style&index=0&id=a09a665a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a665a",
  null
  
)

export default component.exports